import { render, staticRenderFns } from "./inject.vue?vue&type=template&id=07a469f5&scoped=true&"
import script from "./inject.vue?vue&type=script&lang=js&"
export * from "./inject.vue?vue&type=script&lang=js&"
import style0 from "./inject.vue?vue&type=style&index=0&id=07a469f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a469f5",
  null
  
)

export default component.exports